module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAICAYAAAD9aA/QAAAAAXNSR0IArs4c6QAAAF1JREFUKFNjXLx4cToDA0MLAwODCAMW8P///w9MTEwFMTExC0HSxKpnXLRo0XtGRkYBbIYiib2JjY0VBfGJVc+4ePHi/wQMBUvHxsYyQl1MlPpRg+GhStPIo0lyAwBeMU3nXirCHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/weekly/flat.png
// module id = PWBB
// module chunks = 0